import { UserGetCertification } from './Request';

export const userGetCertification = async ({ courseId, userId }) => UserGetCertification({ courseId, userId });

export default {
  userGetCertification,
};
